import { DesignSystem } from '@/src/design-system'
import { Image } from 'expo-image'
import { YStack, H4, Paragraph, View } from 'tamagui'
import * as Mortgage from '@/src/experiences/mortgage'
import { Section } from '../Section'
import { openInAppBrowser } from '@/src/common/utils/openInAppBrowser'
import { Button } from '@/src/common/components/Button'
import {
  SegmentDomainProvider,
  useSegmentDomain,
} from '@/src/services/segment/SegmentDomainProvider'

function InternalPartnerSection({
  partnerCode,
}: {
  partnerCode: Mortgage.Statsig.Store.MortgageModuleVariantName
}) {
  const {
    partner_name,
    title,
    description,
    action_text,
    action_url,
    details_paragraphs,
    image_url,
  } = Mortgage.Statsig.Store.useMortgageModuleDesign(partnerCode)

  const { triggerAction } = useSegmentDomain()

  return (
    <Section title={partner_name ?? title} subtitle={description}>
      <DesignSystem.SplitCard>
        {image_url ? (
          <DesignSystem.SplitCard.ImageHeader containerStyle={{ height: 140 }}>
            <Image source={{ uri: image_url }} contentFit="contain" style={{ height: 140 }} />
          </DesignSystem.SplitCard.ImageHeader>
        ) : null}
        <DesignSystem.SplitCard.Content>
          <YStack gap="$2">
            <H4>{title}</H4>
            {details_paragraphs
              ? details_paragraphs.map((paragraph) => (
                  <Paragraph key={paragraph}>{paragraph}</Paragraph>
                ))
              : null}

            {action_text && action_url ? (
              <>
                <View py="$2" />
                <Button
                  title={action_text}
                  onPress={() => {
                    if (action_url) {
                      void openInAppBrowser(action_url, action_text, 'tab')
                      void triggerAction('PartnerCard', 'ActionPressed', {
                        partnerCode,
                        actionText: action_text,
                        actionUrl: action_url,
                      })
                    }
                  }}
                />
                <View py="$2" />
              </>
            ) : null}
          </YStack>
        </DesignSystem.SplitCard.Content>
      </DesignSystem.SplitCard>
    </Section>
  )
}

export function PartnerSection({
  partnerCode,
}: {
  partnerCode: Mortgage.Statsig.Store.MortgageModuleVariantName
}) {
  return (
    <SegmentDomainProvider domain="PartnerMortgage" domainAdditionalProperties={{ partnerCode }}>
      <InternalPartnerSection partnerCode={partnerCode} />
    </SegmentDomainProvider>
  )
}
